// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "owa." + {"8458":"today","71869":"styles"}[chunkId] + ".p." + {"8458":"2a306267","71869":"2b5c871b"}[chunkId] + ".css";
};